// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/public/bouquet/uang.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
  background-color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#mainContent {
  background-color: hsla(44, 100%, 90%, 0.3);
  padding: 32px;
  flex: 1;
}

.nav-page {
  color: rgb(216, 0, 0);
}

/* Hero */

.judul-landing-page {
  padding: 0 15px;
  color: rgb(216, 0, 0);
  background-color: #ffffff;
  font-size: 50px;
}

.deskripsi-landing-page {
  color: white;
  /* background-color: #ffffff; */
  font-weight: bolder;
}

.hero-image {
  position: relative;
  width: 100%;
  height: 53vh; /* Full screen height */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 60px;
  border-radius: 30px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.373); /* Dark overlay with 50% opacity */
  z-index: 1; /* Ensure the overlay is above the image */
}

.hero-text {
  position: relative;
  text-align: center;
  color: white;
  z-index: 2; /* Ensure the text is above the overlay */
}

.hero-text p {
  margin-top: 12px;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 20px;
}

.buket-kami {
  text-align: center;
  margin-bottom: 20px;
  font-size: 40px;
  color: rgb(216, 0, 0);
}

/* Video Landing Page */
.video-section {
  display: flex;
  justify-content: center;
  margin: 110px 0;
  margin-bottom: 50px;
  padding: 0 12px;
}

.video-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  width: 100%;
  flex-wrap: wrap;
}

.video-text {
  flex: 1;
  font-size: 32px;
  font-weight: bold;
  line-height: 1.2;
  color: #d80000;
}

.video-text p {
  font-weight: lighter;
  font-size: 24px;
  padding-top: 14px;
}

.video-frame {
  flex: 1;
  aspect-ratio: 16 / 9;
  position: relative;
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.video-frame video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Card */
.card-wishlist {
  position: relative;
  box-shadow: -8px 8px rgb(55, 216, 55);
  transition: 0.3s;
  width: 90%;
  max-width: 250px;
  display: flex;
  border-radius: 12px;
  border: 6px solid rgba(255, 27, 27, 0.782);
  margin: 0 auto;
}

/* Tambahkan gaya untuk container di halaman wishlist */
.wishlist-container,
.sort-card {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

/* Atur ulang margin bottom untuk card saat di dalam halaman wishlist */
.wishlist-container .card-wishlist {
  margin-bottom: 20px;
}

@media screen and (max-width: 850px) {
  .sort-card,
  .wishlist-container {
    display: block;
  }

  .card-wishlist {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1035px) {
  .judul-landing-page {
    background-color: transparent;
    color: white;
    font-size: 40px;
  }
}

.image-card {
  width: 100%;
  height: auto;
  border-radius: 5px 5px 0 0;
}

.card-wishlist:hover {
  box-shadow: -12px 12px rgba(255, 27, 27, 0.782);
  cursor: pointer;
}

.button-card {
  padding: 6px;
  margin-top: 7px;
  border-radius: 8px;
  background-color: aliceblue;
  box-shadow: -3.5px 3.5px red;
  color: red;
  font-weight: bolder;
  font-size: 20px;
}

.container {
  padding: 10px 16px;
  border-radius: 0 0 10px 10px;
}

.card-landing-page {
  margin-top: 30px;
}

/* Overlay dengan pseudo-element yang muncul saat di-hover */
/* Teks overlay default untuk landing page */
/* Teks overlay default untuk landing page */
/* Teks default untuk tambah ke wishlist */
.card-wishlist::after {
  content: 'Lihat selengkapnya';
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.8);
  color: white;
  font-size: 1.2em;
  font-weight: bold;
  border-radius: 12px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

/* Tampilkan overlay saat hover */
.card-wishlist:hover::after {
  opacity: 1;
}

/* Teks overlay saat di halaman Wishlist */
.is-wishlist-page .card-wishlist::after {
  content: 'Lihat Selengkapnya';
}

.judul-buket {
  font-size: 25px;
}

.varian-buket {
  font-size: 18px;
}

/* Wishlist */
.wishlist-judul {
  text-align: center;
  margin-bottom: 15px;
  font-weight: bolder;
  font-size: 30px;
  color: rgb(216, 0, 0);
}

.empty-wishlist-message {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: rgb(216, 0, 0);
  font-size: 1.2em;
  height: 100%; /* Agar teks berada di tengah secara vertikal */
}

/*
    AppBar
  */

.app-bar {
  padding: 8px 16px;
  background-color: white;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.app-bar .app-bar__menu {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
}

.app-bar .app-bar__brand {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__brand h1 {
  color: #db0000;
  text-decoration: none;
  font-size: 22px;
  user-select: none;
}

.judul {
  text-decoration: none;
  font-family: 'Playwrite GB S', cursive;
  color: red;
}

.judul:active {
  text-decoration: none;
}

.app-bar .app-bar__navigation {
  position: absolute;
  top: 50px;
  left: -180px;
  width: 150px;
  transition: all 0.3s;
  padding: 8px;
  background-color: white;
  overflow: hidden;
}

.app-bar .app-bar__navigation.open {
  left: 0;
}

.app-bar .app-bar__navigation ul li a {
  display: inline-block;
  text-decoration: none;
  color: rgb(219, 0, 0);
  font-weight: bolder;
  padding: 8px;
  margin-bottom: 5px;
  width: 100%;
}

/*
    Main Content
  */

.content {
  margin: 0 auto;
  min-height: 100%;
}

.content .content__heading {
  font-weight: normal;
}

/* FAQ */

.faq-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding: 0 16px; /* memberikan padding agar tidak terlalu mepet di layar kecil */
}

.card-faq {
  position: relative;
  box-shadow: -8px 8px rgb(55, 216, 55);
  transition: 0.3s;
  width: 100%;
  max-width: 800px; /* batas lebar pada perangkat besar */
  padding: 16px;
  border-radius: 12px;
  border: 6px solid rgba(255, 27, 27, 0.782);
  background-color: #fff;
  text-align: center;
}

.card-faq h3 {
  margin: 0;
  font-size: 1.2em;
  color: #333;
}

.card-faq p {
  margin: 10px 0 0;
  font-size: 1em;
  color: #666;
}

.faq-deskripsi {
  font-weight: bolder;
}

.faq-judul {
  text-align: center;
  color: rgb(216, 0, 0);
}

/*
    Movies
  */

.movies {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin: 32px 0;
}

/*
    Movie Item
  */

.movie-item {
  width: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.movie-item__header {
  position: relative;
}

.movie-item .movie-item__header .movie-item__header__poster {
  width: 100%;
}

.movie-item .movie-item__header .movie-item__header__rating {
  position: absolute;
  padding: 8px;
  bottom: 20px;
  left: 0;
  display: inline-block;
  background-color: black;
  color: white;
}

.movie-item
  .movie-item__header
  .movie-item__header__rating
  .movie-item__header__rating__score {
  margin-left: 10px;
}

.movie-item .movie-item__content {
  padding: 16px;
}

.movie-item .movie-item__content h3 {
  margin: 0 0 10px 0;
}

.movie-item .movie-item__content h3 a {
  color: #db0000;
  text-decoration: none;
}

.movie-item .movie-item__content p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4; /* standard property for compatibility */
  -webkit-box-orient: vertical;
}

/*
    Movie
  */

.movie {
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px 16px;
}

.movie .movie__poster {
  width: 100%;
  max-width: 400px;
}

.movie .movie__info h4 {
  margin: 8px 0;
}

.detail-content {
  display: flex; /* Mengatur layout menjadi flexbox */
  align-items: flex-start; /* Menyelaraskan item ke atas */
  justify-content: center; /* Menjaga elemen tetap di tengah secara horizontal */
  padding: 20px;
  gap: 20px; /* Memberikan jarak antar elemen */
}

.detail-image {
  width: 100%;
  max-width: 300px; /* Atur ukuran maksimum untuk gambar */
  border-radius: 12px;
}

.detail-info {
  display: flex;
  flex-direction: column; /* Mengatur elemen dalam kolom */
  justify-content: center; /* Menyelaraskan konten di tengah */
  max-width: 500px; /* Batas lebar untuk menjaga teks */
}

.detail-info h1,
.detail-info h2,
.detail-info h3 {
  margin: 0 0 10px;
}

.detail-info p {
  text-align: left; /* Menyelaraskan teks ke kiri */
  margin-bottom: 20px;
}

.detail-info p {
  margin: 16px 0;
  line-height: 1.6;
}

/* Buttons Styling */
.detail-buttons {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.icons-detail {
  width: 28px;
  height: 28px;
  filter: brightness(0) saturate(100%) invert(88%) sepia(100%) saturate(2%)
    hue-rotate(299deg) brightness(110%) contrast(101%);
}

.wishlist-button,
.buy-whatsapp,
.buy-instagram,
.buy-facebook,
.buy-tiktok,
.feedback-button {
  padding: 8px 12px 4px 12px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: white;
  font-weight: bold;
}

.feedback-button {
  background-color: #4d869c;
  padding-bottom: 8px;
}
.feedback-button:hover {
  background-color: #37647a;
}

.wishlist-button {
  background-color: #007bff; /* Biru untuk Wishlist */
}

.wishlist-button:hover {
  background-color: #0056b3; /* Biru lebih gelap */
}

.buy-facebook {
  background-color: #3b5998; /* Biru khas Facebook */
}

.buy-facebook:hover {
  background-color: #1a356e; /* Biru lebih gelap */
}

.buy-whatsapp {
  background-color: #25d366; /* Hijau khas WhatsApp */
}

.buy-whatsapp:hover {
  background-color: #1ebe57; /* Hijau lebih gelap */
}

.buy-instagram {
  background-color: #c13584; /* Ungu khas Instagram */
}

.buy-instagram:hover {
  background-color: #a2296f; /* Ungu lebih gelap */
}

.buy-tiktok {
  background-color: #000000; /* Biru khas TikTok */
}

.buy-tiktok:hover {
  background-color: #383838; /* Biru lebih gelap */
}

.wishlist-button {
  padding: 10px 16px;
  font-size: 16px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.wishlist-button:hover {
  background-color: darkred;
}

/* Modal Styles */
.modal {
  display: none; /* Secara default modal disembunyikan */
  position: fixed;
  z-index: 1; /* Pastikan modal muncul di atas konten */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4); /* Latar belakang transparan */
}

/* Modal Styles */
.modal {
  display: none; /* Secara default modal disembunyikan */
  position: fixed;
  z-index: 1; /* Pastikan modal muncul di atas konten */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4); /* Latar belakang transparan */
}

/* Konten Modal */
.modal-content {
  background-color: white;
  margin: 15% auto;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
  max-width: 400px;
  text-align: center;
}

/* Tombol tutup */
.close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 0;
  right: 10px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* Tombol dalam modal */
.modal-button {
  background-color: blue;
  color: white;
  border: none;
  padding: 15px 32px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  margin: 10px;
  font-weight: bolder;
}

.modal-button:hover {
  background-color: rgb(80, 80, 255);
}

#delete-item {
  background-color: red;
}

#delete-item:hover {
  background-color: #ff5d5d;
}

/* login */

.login-container {
  max-width: 400px;
  margin: 60px auto;
  padding: 30px;
  background-color: #f7f7f7;
  border-radius: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  color: #4d869c;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.login-label {
  color: #4d869c;
  font-weight: bold;
  margin-bottom: 6px;
  margin-top: 10px;
}

.login-input {
  padding: 10px;
  border: 1.4px solid #ccc;
  border-radius: 10px;
  margin-bottom: 10px;
}

.login-button {
  background-color: #4d869c;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.login-button:hover {
  background-color: #3c6e83;
}

.login-redirect {
  text-align: center;
  margin-top: 15px;
}

.login-redirect a {
  color: #00008b;
  text-decoration: underline;
}

/* registrasi */
.register-container {
  max-width: 400px;
  margin: 60px auto;
  padding: 30px;
  background-color: #f7f7f7;
  border-radius: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.register-title {
  text-align: center;
  color: #4d869c;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.register-form {
  display: flex;
  flex-direction: column;
}

.register-label {
  color: #4d869c;
  font-weight: bold;
  margin-bottom: 6px;
  margin-top: 10px;
}

.register-input {
  padding: 10px;
  border: 1.4px solid #ccc;
  border-radius: 10px;
  margin-bottom: 10px;
}

.register-button {
  background-color: #4d869c;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.register-button:hover {
  background-color: #3c6e83;
}

.register-redirect {
  text-align: center;
  margin-top: 15px;
}

.register-redirect a {
  color: #00008b;
  text-decoration: underline;
}

/*
    Footer
  */

footer {
  padding: 16px;
}
.footer-desc {
  text-align: center;
  margin: 10px 0;
  font-size: 14px;
  color: #858585;
}

footer p {
  text-align: center;
  margin: 10px 0;
  font-size: 14px;
  color: #858585;
}

footer p a {
  color: #db0000;
  text-decoration: none;
  margin: 0 5px;
  font-weight: bold;
}

footer p a:hover {
  color: #555555;
  text-decoration: underline;
}

/* Feedback Page Styles */
.feedback-page {
  margin: 2rem auto;
  max-width: 900px; /* sebelumnya 600px, sekarang lebih lebar */
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);
  padding: 2.5rem 2rem 2rem 2rem;
  min-width: 0;
  box-sizing: border-box;
}

.feedback-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  /* padding: 16px; */
  gap: 18px;
}

.feedback-title {
  color: #222;
  font-size: 2.1rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin-bottom: 6px;
}

.feedback-form label {
  display: block;
  font-weight: 600;
  color: #4d869c;
  margin-bottom: 0.4rem;
  margin-top: 1.2rem;
  font-size: 1.05em;
}

.feedback-form input[type='file'] {
  display: block;
  width: 100%;
  font-size: 1em;
  padding: 0.5em 0.7em;
  border: 1.5px solid #d3d3d3;
  border-radius: 8px;
  background: #fafbfc;
  margin-bottom: 0.5rem;
}

#preview-gambar {
  display: block;
  margin: 0.5rem 0 0.8rem 0;
  border-radius: 10px;
  border: 1.5px solid #e0e0e0;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
  max-width: 160px;
  max-height: 120px;
  object-fit: cover;
}

.feedback-form select,
.feedback-form input[type='text'],
.feedback-form textarea {
  width: 100%;
  padding: 0.7em 1em;
  border: 1.5px solid #d3d3d3;
  border-radius: 8px;
  background: #fafbfc;
  font-size: 1em;
  margin-bottom: 0.2rem;
  transition: border 0.2s;
}

.feedback-form select:focus,
.feedback-form input[type='text']:focus,
.feedback-form textarea:focus {
  border: 1.5px solid #4d869c;
  outline: none;
}

.feedback-form textarea {
  min-height: 80px;
  resize: vertical;
  font-family: inherit;
}

.rating-stars {
  display: flex;
  gap: 8px;
  margin: 0.5rem 0 1rem 0;
  align-items: center;
}

.star-icon {
  width: 32px;
  height: 32px;
  transition: transform 0.1s;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.07));
}
.star-icon:hover,
.star-icon:active {
  transform: scale(1.13);
  filter: brightness(1.2) drop-shadow(0 2px 6px rgba(77, 134, 156, 0.13));
}

.feedback-submit-btn {
  width: 100%;
  background: linear-gradient(90deg, #4d869c 60%, #7ec6e3 100%);
  color: #fff;
  font-weight: bold;
  font-size: 1.1em;
  border: none;
  border-radius: 10px;
  padding: 0.9em 0;
  margin-top: 1.5rem;
  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.08);
  cursor: pointer;
  transition: background 0.18s, box-shadow 0.18s;
}
.feedback-submit-btn:hover {
  background: linear-gradient(90deg, #37647a 60%, #4d869c 100%);
  box-shadow: 0 4px 16px 0 rgba(77, 134, 156, 0.13);
}

#feedback-success {
  text-align: center;
  font-weight: bold;
  color: #4caf50 !important;
  margin-top: 1.5rem;
  font-size: 1.1em;
  letter-spacing: 0.5px;
}

#feedback-loading {
  text-align: center;
  font-weight: bold;
  color: rgb(255, 98, 0) !important;
  margin-top: 1.5rem;
  font-size: 1.1em;
  letter-spacing: 0.5px;
}

/* Responsive Feedback Page */
@media (max-width: 700px) {
  .feedback-page {
    padding: 1.2rem 0.5rem 1.5rem 0.5rem;
    margin: 1rem 0.2rem;
  }
}

/* Navbar Feedback Link */
.app-bar__navigation ul li.nav-feedback {
  display: inline-block;
}
.app-bar__navigation ul li.nav-feedback a {
  color: #4d869c;
  font-weight: bold;
  font-size: 1em;
  padding: 8px;
  text-decoration: none;
  transition: color 0.18s;
}
.app-bar__navigation ul li.nav-feedback a:hover {
  color: #db0000;
  text-decoration: underline;
}

/* Admin Bouquet Page Styles */
.bouquet-page {
  margin: 2rem auto;
  max-width: 1200px; /* sebelumnya 1100px, sekarang lebih lebar */
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);
  padding: 2.5rem 2rem 2rem 2rem;
  /* Tambahkan min-width agar tidak terlalu kecil di desktop besar */
  min-width: 0;
  box-sizing: border-box;
}

.bouquet-header {
  display: flex;
  align-items: center;
  /* margin-bottom: 0.5rem; */
  margin-top: -30px;
}

.bouquet-title {
  color: #4d869c;
  font-weight: bold;
  margin-right: 0.2rem;
  font-size: 2rem;
}

.bouquet-feedback-link {
  font-size: 0.95em;
  color: #888;
  cursor: pointer;
  margin-left: 3px;
  padding-left: 0.2rem;
  transition: color 0.2s;
  text-decoration: none;
  align-self: flex-end;
  margin-bottom: 2px;
  vertical-align: middle;
  font-weight: bolder;
}
.bouquet-feedback-link:hover {
  color: #4d869c;
  text-decoration: none;
}

.bouquet-tambah-btn {
  margin: 7px 0 13px 0px;
  padding: 0.5rem 1rem;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1.05em;
  transition: background 0.18s;
}
.bouquet-tambah-btn:hover {
  background-color: #388e3c;
}

.bouquet-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  background: #fafbfc;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.07);
}

.bouquet-table th,
.bouquet-table td {
  border: 1px solid #ccc;
  padding: 10px 8px;
  vertical-align: middle;
  font-size: 1em;
}

.bouquet-table thead {
  background-color: #f0f0f0;
}

.bouquet-logout-btn {
  margin-top: 1.5rem;
  padding: 0.5rem 1rem;
  background-color: #ff4d4d;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1.05em;
  transition: background 0.18s;
}
.bouquet-logout-btn:hover {
  background-color: #d93636;
}

.bouquet-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  justify-content: center;
  align-items: center;
}

.bouquet-modal-content {
  background: white;
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

@media (max-width: 500px) {
  .bouquet-modal-content {
    width: 95vw;
    padding: 1rem;
  }
}

.bouquet-img-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bouquet-preview-gambar {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  margin: 0;
}

.bouquet-table-img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}

.bouquet-input {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 6px 8px;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
}

.bouquet-textarea {
  resize: vertical;
  min-height: 60px;
  max-width: 100%;
  min-width: 100%;
  max-height: 160px;
  font-family: inherit;
}

.bouquet-submit-btn {
  padding: 0.5rem 1rem;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  margin-right: 0.5rem;
  font-size: 1em;
  transition: background 0.18s;
}
.bouquet-submit-btn:hover {
  background-color: #388e3c;
}

.bouquet-cancel-btn {
  padding: 0.5rem 1rem;
  background-color: #ccc;
  color: #333;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1em;
  transition: background 0.18s;
}
.bouquet-cancel-btn:hover {
  background-color: #b0b0b0;
}

.bouquet-action-center {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.bouquet-action-btn {
  padding: 0.3rem 0.8rem;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.95em;
  transition: background 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 32px;
  line-height: 1.2;
}

.bouquet-edit-btn {
  background: #4d869c;
  color: #fff;
}
.bouquet-edit-btn:hover {
  background: #37647a;
}

.bouquet-delete-btn {
  background: #ff4d4d;
  color: #fff;
}
.bouquet-delete-btn:hover {
  background: #d93636;
}

.bouquet-search-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: -60px;
  margin-bottom: 10px;
}

.bouquet-search-input {
  width: 250px;
  padding: 7px 12px;
  border: 1.5px solid #ccc;
  border-radius: 6px;
  font-size: 1em;
  margin-top: 10px;
  outline: none;
  transition: border 0.2s;
}
.bouquet-search-input:focus {
  border: 1.5px solid #4d869c;
}

.bouquet-search-btn {
  padding: 7px 18px;
  border-radius: 6px;
  border: none;
  background: #4d869c;
  color: #fff;
  font-weight: bold;
  font-size: 1em;
  margin-top: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.bouquet-search-btn:hover {
  background: #37647a;
}

.see-more {
  color: #4d869c;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.98em;
  margin-left: 4px;
}

/* Ensure .bouquet-deskripsi wraps text and prevents horizontal scroll/overflow */
.bouquet-deskripsi {
  display: block;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 250px;
  overflow-x: auto;
}

/* Prevent table cell overflow for deskripsi */
.bouquet-table td,
.bouquet-table th {
  vertical-align: top;
  word-break: break-word;
  white-space: normal;
  max-width: 260px;
  overflow-wrap: break-word;
}

.bouquet-file-preview-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Admin Feedback Table Styles */
.admin-feedback-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  background: #fafbfc;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.07);
}

.admin-feedback-table th,
.admin-feedback-table td {
  border: 1px solid #ccc;
  padding: 10px 8px;
  vertical-align: middle;
  font-size: 1em;
}

.admin-feedback-table thead {
  background-color: #f0f0f0;
}

.admin-feedback-img-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.admin-feedback-table-img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}

/* Prevent table header text from wrapping to new line */
.bouquet-table th,
.admin-feedback-table th {
  white-space: nowrap;
}

/* Prevent action button text from wrapping to new line */
.bouquet-action-btn,
.bouquet-edit-btn,
.bouquet-delete-btn {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 32px;
  line-height: 1.2;
  padding: 0.3rem 0.8rem;
}

/* Optional: Prevent sort icon and th text from stacking vertically */
.bouquet-table th .th-flex,
.admin-feedback-table th .th-flex {
  flex-wrap: nowrap;
  gap: 6px;
}

/* feedback card detail */
.feedback-list {
  font-weight: bolder;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
}

#feedback-list-container {
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center; /* ini bikin konten feedback card di tengah */
}

@media (min-width: 700px) {
  .feedback-list {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

.feedback-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start; /* Ubah ini dari center menjadi flex-start */
  /* flex-direction: column; otomatis taruh isi ke bawah */
  /* align-items: center; <--- Hapus atau komentari baris ini jika ada duplikasi */
  text-align: left;
  width: 350px;
  max-width: 600px;
  gap: 12px;
  padding: 16px;
  border: 6px solid rgba(255, 27, 27, 0.782);
  border-radius: 12px;
  background-color: hsla(44, 100%, 90%, 0.3);
  max-width: 100%;
  box-shadow: -8px 8px rgb(55, 216, 55);
}

.feedback-img-wrapper img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.feedback-content {
  flex: 1;
  /* margin-top: 10px; */
  word-break: break-word;
}

.feedback-rating {
  font-weight: bold;
  margin-bottom: -7px !important;
  margin-top: 3px !important;
}

.feedback-text {
  font-size: 14px;
  font-weight: bolder;
  color: #444;
  margin-top: 8px;
}

.no-feedback {
  text-align: center;
  font-style: italic;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA,SAAS;;AAET;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,uBAAuB;EACrC,yDAA0D;EAC1D,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC,EAAE,kCAAkC;EAC1E,UAAU,EAAE,0CAA0C;AACxD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAE,yCAAyC;AACvD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,uDAAuD;AACvD;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D,4CAA4C;AAC5C,4CAA4C;AAC5C,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,QAAQ;;AAER;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe,EAAE,+DAA+D;AAClF;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE,qCAAqC;EACvD,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB,EAAE,4BAA4B;EACnD,aAAa,EAAE,wCAAwC;EACvD,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa,EAAE,oCAAoC;EACnD,uBAAuB,EAAE,+BAA+B;EACxD,uBAAuB,EAAE,qDAAqD;EAC9E,aAAa;EACb,SAAS,EAAE,kCAAkC;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,sCAAsC;EACxD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,gCAAgC;EACxD,uBAAuB,EAAE,mCAAmC;EAC5D,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,EAAE,+BAA+B;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;sDACoD;AACtD;;AAEA;;;;;;EAME,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,uCAAuC;EACtD,eAAe;EACf,UAAU,EAAE,yCAAyC;EACrD,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,8BAA8B;AACtE;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,uCAAuC;EACtD,eAAe;EACf,UAAU,EAAE,yCAAyC;EACrD,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,8BAA8B;AACtE;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;;AAEV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,gBAAgB,EAAE,2CAA2C;EAC7D,gBAAgB;EAChB,mBAAmB;EACnB;qCACmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;EAGE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;;EAEE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,6DAA6D;EAC7D,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE;IACE,oCAAoC;IACpC,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,iBAAiB,EAAE,4CAA4C;EAC/D,gBAAgB;EAChB,mBAAmB;EACnB;qCACmC;EACnC,8BAA8B;EAC9B,kEAAkE;EAClE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,wDAAwD;AACxD;;EAEE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;;EAGE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;;EAEE,iBAAiB;EACjB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB,EAAE,6CAA6C;AACpE;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAE,4CAA4C;EACrE,wDAAwD;EACxD,gFAAgF;EAChF,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n#mainContent {\n  background-color: hsla(44, 100%, 90%, 0.3);\n  padding: 32px;\n  flex: 1;\n}\n\n.nav-page {\n  color: rgb(216, 0, 0);\n}\n\n/* Hero */\n\n.judul-landing-page {\n  padding: 0 15px;\n  color: rgb(216, 0, 0);\n  background-color: #ffffff;\n  font-size: 50px;\n}\n\n.deskripsi-landing-page {\n  color: white;\n  /* background-color: #ffffff; */\n  font-weight: bolder;\n}\n\n.hero-image {\n  position: relative;\n  width: 100%;\n  height: 53vh; /* Full screen height */\n  background-image: url('../../src/public/bouquet/uang.jpg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  margin-bottom: 60px;\n  border-radius: 30px;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.373); /* Dark overlay with 50% opacity */\n  z-index: 1; /* Ensure the overlay is above the image */\n}\n\n.hero-text {\n  position: relative;\n  text-align: center;\n  color: white;\n  z-index: 2; /* Ensure the text is above the overlay */\n}\n\n.hero-text p {\n  margin-top: 12px;\n  margin-left: 20px;\n  margin-right: 20px;\n  font-size: 20px;\n}\n\n.buket-kami {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 40px;\n  color: rgb(216, 0, 0);\n}\n\n/* Video Landing Page */\n.video-section {\n  display: flex;\n  justify-content: center;\n  margin: 110px 0;\n  margin-bottom: 50px;\n  padding: 0 12px;\n}\n\n.video-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n  max-width: 1200px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.video-text {\n  flex: 1;\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 1.2;\n  color: #d80000;\n}\n\n.video-text p {\n  font-weight: lighter;\n  font-size: 24px;\n  padding-top: 14px;\n}\n\n.video-frame {\n  flex: 1;\n  aspect-ratio: 16 / 9;\n  position: relative;\n  width: 100%;\n  max-width: 600px;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.video-frame video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Card */\n.card-wishlist {\n  position: relative;\n  box-shadow: -8px 8px rgb(55, 216, 55);\n  transition: 0.3s;\n  width: 90%;\n  max-width: 250px;\n  display: flex;\n  border-radius: 12px;\n  border: 6px solid rgba(255, 27, 27, 0.782);\n  margin: 0 auto;\n}\n\n/* Tambahkan gaya untuk container di halaman wishlist */\n.wishlist-container,\n.sort-card {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* Atur ulang margin bottom untuk card saat di dalam halaman wishlist */\n.wishlist-container .card-wishlist {\n  margin-bottom: 20px;\n}\n\n@media screen and (max-width: 850px) {\n  .sort-card,\n  .wishlist-container {\n    display: block;\n  }\n\n  .card-wishlist {\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 1035px) {\n  .judul-landing-page {\n    background-color: transparent;\n    color: white;\n    font-size: 40px;\n  }\n}\n\n.image-card {\n  width: 100%;\n  height: auto;\n  border-radius: 5px 5px 0 0;\n}\n\n.card-wishlist:hover {\n  box-shadow: -12px 12px rgba(255, 27, 27, 0.782);\n  cursor: pointer;\n}\n\n.button-card {\n  padding: 6px;\n  margin-top: 7px;\n  border-radius: 8px;\n  background-color: aliceblue;\n  box-shadow: -3.5px 3.5px red;\n  color: red;\n  font-weight: bolder;\n  font-size: 20px;\n}\n\n.container {\n  padding: 10px 16px;\n  border-radius: 0 0 10px 10px;\n}\n\n.card-landing-page {\n  margin-top: 30px;\n}\n\n/* Overlay dengan pseudo-element yang muncul saat di-hover */\n/* Teks overlay default untuk landing page */\n/* Teks overlay default untuk landing page */\n/* Teks default untuk tambah ke wishlist */\n.card-wishlist::after {\n  content: 'Lihat selengkapnya';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(128, 128, 128, 0.8);\n  color: white;\n  font-size: 1.2em;\n  font-weight: bold;\n  border-radius: 12px;\n  text-align: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n/* Tampilkan overlay saat hover */\n.card-wishlist:hover::after {\n  opacity: 1;\n}\n\n/* Teks overlay saat di halaman Wishlist */\n.is-wishlist-page .card-wishlist::after {\n  content: 'Lihat Selengkapnya';\n}\n\n.judul-buket {\n  font-size: 25px;\n}\n\n.varian-buket {\n  font-size: 18px;\n}\n\n/* Wishlist */\n.wishlist-judul {\n  text-align: center;\n  margin-bottom: 15px;\n  font-weight: bolder;\n  font-size: 30px;\n  color: rgb(216, 0, 0);\n}\n\n.empty-wishlist-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  color: rgb(216, 0, 0);\n  font-size: 1.2em;\n  height: 100%; /* Agar teks berada di tengah secara vertikal */\n}\n\n/*\n    AppBar\n  */\n\n.app-bar {\n  padding: 8px 16px;\n  background-color: white;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.app-bar .app-bar__menu {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__menu button {\n  background-color: transparent;\n  border: none;\n  font-size: 18px;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.app-bar .app-bar__brand {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__brand h1 {\n  color: #db0000;\n  text-decoration: none;\n  font-size: 22px;\n  user-select: none;\n}\n\n.judul {\n  text-decoration: none;\n  font-family: 'Playwrite GB S', cursive;\n  color: red;\n}\n\n.judul:active {\n  text-decoration: none;\n}\n\n.app-bar .app-bar__navigation {\n  position: absolute;\n  top: 50px;\n  left: -180px;\n  width: 150px;\n  transition: all 0.3s;\n  padding: 8px;\n  background-color: white;\n  overflow: hidden;\n}\n\n.app-bar .app-bar__navigation.open {\n  left: 0;\n}\n\n.app-bar .app-bar__navigation ul li a {\n  display: inline-block;\n  text-decoration: none;\n  color: rgb(219, 0, 0);\n  font-weight: bolder;\n  padding: 8px;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n/*\n    Main Content\n  */\n\n.content {\n  margin: 0 auto;\n  min-height: 100%;\n}\n\n.content .content__heading {\n  font-weight: normal;\n}\n\n/* FAQ */\n\n.faq-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n  padding: 0 16px; /* memberikan padding agar tidak terlalu mepet di layar kecil */\n}\n\n.card-faq {\n  position: relative;\n  box-shadow: -8px 8px rgb(55, 216, 55);\n  transition: 0.3s;\n  width: 100%;\n  max-width: 800px; /* batas lebar pada perangkat besar */\n  padding: 16px;\n  border-radius: 12px;\n  border: 6px solid rgba(255, 27, 27, 0.782);\n  background-color: #fff;\n  text-align: center;\n}\n\n.card-faq h3 {\n  margin: 0;\n  font-size: 1.2em;\n  color: #333;\n}\n\n.card-faq p {\n  margin: 10px 0 0;\n  font-size: 1em;\n  color: #666;\n}\n\n.faq-deskripsi {\n  font-weight: bolder;\n}\n\n.faq-judul {\n  text-align: center;\n  color: rgb(216, 0, 0);\n}\n\n/*\n    Movies\n  */\n\n.movies {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin: 32px 0;\n}\n\n/*\n    Movie Item\n  */\n\n.movie-item {\n  width: 100%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.movie-item__header {\n  position: relative;\n}\n\n.movie-item .movie-item__header .movie-item__header__poster {\n  width: 100%;\n}\n\n.movie-item .movie-item__header .movie-item__header__rating {\n  position: absolute;\n  padding: 8px;\n  bottom: 20px;\n  left: 0;\n  display: inline-block;\n  background-color: black;\n  color: white;\n}\n\n.movie-item\n  .movie-item__header\n  .movie-item__header__rating\n  .movie-item__header__rating__score {\n  margin-left: 10px;\n}\n\n.movie-item .movie-item__content {\n  padding: 16px;\n}\n\n.movie-item .movie-item__content h3 {\n  margin: 0 0 10px 0;\n}\n\n.movie-item .movie-item__content h3 a {\n  color: #db0000;\n  text-decoration: none;\n}\n\n.movie-item .movie-item__content p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 4; /* number of lines to show */\n  line-clamp: 4; /* standard property for compatibility */\n  -webkit-box-orient: vertical;\n}\n\n/*\n    Movie\n  */\n\n.movie {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 800px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px 16px;\n}\n\n.movie .movie__poster {\n  width: 100%;\n  max-width: 400px;\n}\n\n.movie .movie__info h4 {\n  margin: 8px 0;\n}\n\n.detail-content {\n  display: flex; /* Mengatur layout menjadi flexbox */\n  align-items: flex-start; /* Menyelaraskan item ke atas */\n  justify-content: center; /* Menjaga elemen tetap di tengah secara horizontal */\n  padding: 20px;\n  gap: 20px; /* Memberikan jarak antar elemen */\n}\n\n.detail-image {\n  width: 100%;\n  max-width: 300px; /* Atur ukuran maksimum untuk gambar */\n  border-radius: 12px;\n}\n\n.detail-info {\n  display: flex;\n  flex-direction: column; /* Mengatur elemen dalam kolom */\n  justify-content: center; /* Menyelaraskan konten di tengah */\n  max-width: 500px; /* Batas lebar untuk menjaga teks */\n}\n\n.detail-info h1,\n.detail-info h2,\n.detail-info h3 {\n  margin: 0 0 10px;\n}\n\n.detail-info p {\n  text-align: left; /* Menyelaraskan teks ke kiri */\n  margin-bottom: 20px;\n}\n\n.detail-info p {\n  margin: 16px 0;\n  line-height: 1.6;\n}\n\n/* Buttons Styling */\n.detail-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.icons-detail {\n  width: 28px;\n  height: 28px;\n  filter: brightness(0) saturate(100%) invert(88%) sepia(100%) saturate(2%)\n    hue-rotate(299deg) brightness(110%) contrast(101%);\n}\n\n.wishlist-button,\n.buy-whatsapp,\n.buy-instagram,\n.buy-facebook,\n.buy-tiktok,\n.feedback-button {\n  padding: 8px 12px 4px 12px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  color: white;\n  font-weight: bold;\n}\n\n.feedback-button {\n  background-color: #4d869c;\n  padding-bottom: 8px;\n}\n.feedback-button:hover {\n  background-color: #37647a;\n}\n\n.wishlist-button {\n  background-color: #007bff; /* Biru untuk Wishlist */\n}\n\n.wishlist-button:hover {\n  background-color: #0056b3; /* Biru lebih gelap */\n}\n\n.buy-facebook {\n  background-color: #3b5998; /* Biru khas Facebook */\n}\n\n.buy-facebook:hover {\n  background-color: #1a356e; /* Biru lebih gelap */\n}\n\n.buy-whatsapp {\n  background-color: #25d366; /* Hijau khas WhatsApp */\n}\n\n.buy-whatsapp:hover {\n  background-color: #1ebe57; /* Hijau lebih gelap */\n}\n\n.buy-instagram {\n  background-color: #c13584; /* Ungu khas Instagram */\n}\n\n.buy-instagram:hover {\n  background-color: #a2296f; /* Ungu lebih gelap */\n}\n\n.buy-tiktok {\n  background-color: #000000; /* Biru khas TikTok */\n}\n\n.buy-tiktok:hover {\n  background-color: #383838; /* Biru lebih gelap */\n}\n\n.wishlist-button {\n  padding: 10px 16px;\n  font-size: 16px;\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.wishlist-button:hover {\n  background-color: darkred;\n}\n\n/* Modal Styles */\n.modal {\n  display: none; /* Secara default modal disembunyikan */\n  position: fixed;\n  z-index: 1; /* Pastikan modal muncul di atas konten */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4); /* Latar belakang transparan */\n}\n\n/* Modal Styles */\n.modal {\n  display: none; /* Secara default modal disembunyikan */\n  position: fixed;\n  z-index: 1; /* Pastikan modal muncul di atas konten */\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4); /* Latar belakang transparan */\n}\n\n/* Konten Modal */\n.modal-content {\n  background-color: white;\n  margin: 15% auto;\n  padding: 20px;\n  border-radius: 10px;\n  width: 80%;\n  max-width: 400px;\n  text-align: center;\n}\n\n/* Tombol tutup */\n.close {\n  color: #aaa;\n  font-size: 28px;\n  font-weight: bold;\n  position: absolute;\n  top: 0;\n  right: 10px;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* Tombol dalam modal */\n.modal-button {\n  background-color: blue;\n  color: white;\n  border: none;\n  padding: 15px 32px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 8px;\n  margin: 10px;\n  font-weight: bolder;\n}\n\n.modal-button:hover {\n  background-color: rgb(80, 80, 255);\n}\n\n#delete-item {\n  background-color: red;\n}\n\n#delete-item:hover {\n  background-color: #ff5d5d;\n}\n\n/* login */\n\n.login-container {\n  max-width: 400px;\n  margin: 60px auto;\n  padding: 30px;\n  background-color: #f7f7f7;\n  border-radius: 16px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.login-title {\n  text-align: center;\n  color: #4d869c;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.login-label {\n  color: #4d869c;\n  font-weight: bold;\n  margin-bottom: 6px;\n  margin-top: 10px;\n}\n\n.login-input {\n  padding: 10px;\n  border: 1.4px solid #ccc;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.login-button {\n  background-color: #4d869c;\n  color: #fff;\n  padding: 10px;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.login-button:hover {\n  background-color: #3c6e83;\n}\n\n.login-redirect {\n  text-align: center;\n  margin-top: 15px;\n}\n\n.login-redirect a {\n  color: #00008b;\n  text-decoration: underline;\n}\n\n/* registrasi */\n.register-container {\n  max-width: 400px;\n  margin: 60px auto;\n  padding: 30px;\n  background-color: #f7f7f7;\n  border-radius: 16px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.register-title {\n  text-align: center;\n  color: #4d869c;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.register-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.register-label {\n  color: #4d869c;\n  font-weight: bold;\n  margin-bottom: 6px;\n  margin-top: 10px;\n}\n\n.register-input {\n  padding: 10px;\n  border: 1.4px solid #ccc;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.register-button {\n  background-color: #4d869c;\n  color: #fff;\n  padding: 10px;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.register-button:hover {\n  background-color: #3c6e83;\n}\n\n.register-redirect {\n  text-align: center;\n  margin-top: 15px;\n}\n\n.register-redirect a {\n  color: #00008b;\n  text-decoration: underline;\n}\n\n/*\n    Footer\n  */\n\nfooter {\n  padding: 16px;\n}\n.footer-desc {\n  text-align: center;\n  margin: 10px 0;\n  font-size: 14px;\n  color: #858585;\n}\n\nfooter p {\n  text-align: center;\n  margin: 10px 0;\n  font-size: 14px;\n  color: #858585;\n}\n\nfooter p a {\n  color: #db0000;\n  text-decoration: none;\n  margin: 0 5px;\n  font-weight: bold;\n}\n\nfooter p a:hover {\n  color: #555555;\n  text-decoration: underline;\n}\n\n/* Feedback Page Styles */\n.feedback-page {\n  margin: 2rem auto;\n  max-width: 900px; /* sebelumnya 600px, sekarang lebih lebar */\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),\n    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);\n  padding: 2.5rem 2rem 2rem 2rem;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.feedback-header {\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  /* padding: 16px; */\n  gap: 18px;\n}\n\n.feedback-title {\n  color: #222;\n  font-size: 2.1rem;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 700;\n  letter-spacing: -1px;\n  margin-bottom: 6px;\n}\n\n.feedback-form label {\n  display: block;\n  font-weight: 600;\n  color: #4d869c;\n  margin-bottom: 0.4rem;\n  margin-top: 1.2rem;\n  font-size: 1.05em;\n}\n\n.feedback-form input[type='file'] {\n  display: block;\n  width: 100%;\n  font-size: 1em;\n  padding: 0.5em 0.7em;\n  border: 1.5px solid #d3d3d3;\n  border-radius: 8px;\n  background: #fafbfc;\n  margin-bottom: 0.5rem;\n}\n\n#preview-gambar {\n  display: block;\n  margin: 0.5rem 0 0.8rem 0;\n  border-radius: 10px;\n  border: 1.5px solid #e0e0e0;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);\n  max-width: 160px;\n  max-height: 120px;\n  object-fit: cover;\n}\n\n.feedback-form select,\n.feedback-form input[type='text'],\n.feedback-form textarea {\n  width: 100%;\n  padding: 0.7em 1em;\n  border: 1.5px solid #d3d3d3;\n  border-radius: 8px;\n  background: #fafbfc;\n  font-size: 1em;\n  margin-bottom: 0.2rem;\n  transition: border 0.2s;\n}\n\n.feedback-form select:focus,\n.feedback-form input[type='text']:focus,\n.feedback-form textarea:focus {\n  border: 1.5px solid #4d869c;\n  outline: none;\n}\n\n.feedback-form textarea {\n  min-height: 80px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.rating-stars {\n  display: flex;\n  gap: 8px;\n  margin: 0.5rem 0 1rem 0;\n  align-items: center;\n}\n\n.star-icon {\n  width: 32px;\n  height: 32px;\n  transition: transform 0.1s;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.07));\n}\n.star-icon:hover,\n.star-icon:active {\n  transform: scale(1.13);\n  filter: brightness(1.2) drop-shadow(0 2px 6px rgba(77, 134, 156, 0.13));\n}\n\n.feedback-submit-btn {\n  width: 100%;\n  background: linear-gradient(90deg, #4d869c 60%, #7ec6e3 100%);\n  color: #fff;\n  font-weight: bold;\n  font-size: 1.1em;\n  border: none;\n  border-radius: 10px;\n  padding: 0.9em 0;\n  margin-top: 1.5rem;\n  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.08);\n  cursor: pointer;\n  transition: background 0.18s, box-shadow 0.18s;\n}\n.feedback-submit-btn:hover {\n  background: linear-gradient(90deg, #37647a 60%, #4d869c 100%);\n  box-shadow: 0 4px 16px 0 rgba(77, 134, 156, 0.13);\n}\n\n#feedback-success {\n  text-align: center;\n  font-weight: bold;\n  color: #4caf50 !important;\n  margin-top: 1.5rem;\n  font-size: 1.1em;\n  letter-spacing: 0.5px;\n}\n\n#feedback-loading {\n  text-align: center;\n  font-weight: bold;\n  color: rgb(255, 98, 0) !important;\n  margin-top: 1.5rem;\n  font-size: 1.1em;\n  letter-spacing: 0.5px;\n}\n\n/* Responsive Feedback Page */\n@media (max-width: 700px) {\n  .feedback-page {\n    padding: 1.2rem 0.5rem 1.5rem 0.5rem;\n    margin: 1rem 0.2rem;\n  }\n}\n\n/* Navbar Feedback Link */\n.app-bar__navigation ul li.nav-feedback {\n  display: inline-block;\n}\n.app-bar__navigation ul li.nav-feedback a {\n  color: #4d869c;\n  font-weight: bold;\n  font-size: 1em;\n  padding: 8px;\n  text-decoration: none;\n  transition: color 0.18s;\n}\n.app-bar__navigation ul li.nav-feedback a:hover {\n  color: #db0000;\n  text-decoration: underline;\n}\n\n/* Admin Bouquet Page Styles */\n.bouquet-page {\n  margin: 2rem auto;\n  max-width: 1200px; /* sebelumnya 1100px, sekarang lebih lebar */\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),\n    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);\n  padding: 2.5rem 2rem 2rem 2rem;\n  /* Tambahkan min-width agar tidak terlalu kecil di desktop besar */\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.bouquet-header {\n  display: flex;\n  align-items: center;\n  /* margin-bottom: 0.5rem; */\n  margin-top: -30px;\n}\n\n.bouquet-title {\n  color: #4d869c;\n  font-weight: bold;\n  margin-right: 0.2rem;\n  font-size: 2rem;\n}\n\n.bouquet-feedback-link {\n  font-size: 0.95em;\n  color: #888;\n  cursor: pointer;\n  margin-left: 3px;\n  padding-left: 0.2rem;\n  transition: color 0.2s;\n  text-decoration: none;\n  align-self: flex-end;\n  margin-bottom: 2px;\n  vertical-align: middle;\n  font-weight: bolder;\n}\n.bouquet-feedback-link:hover {\n  color: #4d869c;\n  text-decoration: none;\n}\n\n.bouquet-tambah-btn {\n  margin: 7px 0 13px 0px;\n  padding: 0.5rem 1rem;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n  font-weight: bold;\n  font-size: 1.05em;\n  transition: background 0.18s;\n}\n.bouquet-tambah-btn:hover {\n  background-color: #388e3c;\n}\n\n.bouquet-table {\n  width: 100%;\n  margin-top: 1rem;\n  border-collapse: collapse;\n  background: #fafbfc;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.07);\n}\n\n.bouquet-table th,\n.bouquet-table td {\n  border: 1px solid #ccc;\n  padding: 10px 8px;\n  vertical-align: middle;\n  font-size: 1em;\n}\n\n.bouquet-table thead {\n  background-color: #f0f0f0;\n}\n\n.bouquet-logout-btn {\n  margin-top: 1.5rem;\n  padding: 0.5rem 1rem;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n  font-weight: bold;\n  font-size: 1.05em;\n  transition: background 0.18s;\n}\n.bouquet-logout-btn:hover {\n  background-color: #d93636;\n}\n\n.bouquet-modal {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  justify-content: center;\n  align-items: center;\n}\n\n.bouquet-modal-content {\n  background: white;\n  padding: 2rem;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n@media (max-width: 500px) {\n  .bouquet-modal-content {\n    width: 95vw;\n    padding: 1rem;\n  }\n}\n\n.bouquet-img-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bouquet-preview-gambar {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 4px;\n  display: block;\n  margin: 0;\n}\n\n.bouquet-table-img {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 4px;\n  display: block;\n  margin: 0 auto;\n}\n\n.bouquet-input {\n  width: 100%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  padding: 6px 8px;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n  box-sizing: border-box;\n}\n\n.bouquet-textarea {\n  resize: vertical;\n  min-height: 60px;\n  max-width: 100%;\n  min-width: 100%;\n  max-height: 160px;\n  font-family: inherit;\n}\n\n.bouquet-submit-btn {\n  padding: 0.5rem 1rem;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  margin-right: 0.5rem;\n  font-size: 1em;\n  transition: background 0.18s;\n}\n.bouquet-submit-btn:hover {\n  background-color: #388e3c;\n}\n\n.bouquet-cancel-btn {\n  padding: 0.5rem 1rem;\n  background-color: #ccc;\n  color: #333;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 1em;\n  transition: background 0.18s;\n}\n.bouquet-cancel-btn:hover {\n  background-color: #b0b0b0;\n}\n\n.bouquet-action-center {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.bouquet-action-btn {\n  padding: 0.3rem 0.8rem;\n  border: none;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  font-size: 0.95em;\n  transition: background 0.2s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  min-height: 32px;\n  line-height: 1.2;\n}\n\n.bouquet-edit-btn {\n  background: #4d869c;\n  color: #fff;\n}\n.bouquet-edit-btn:hover {\n  background: #37647a;\n}\n\n.bouquet-delete-btn {\n  background: #ff4d4d;\n  color: #fff;\n}\n.bouquet-delete-btn:hover {\n  background: #d93636;\n}\n\n.bouquet-search-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: -60px;\n  margin-bottom: 10px;\n}\n\n.bouquet-search-input {\n  width: 250px;\n  padding: 7px 12px;\n  border: 1.5px solid #ccc;\n  border-radius: 6px;\n  font-size: 1em;\n  margin-top: 10px;\n  outline: none;\n  transition: border 0.2s;\n}\n.bouquet-search-input:focus {\n  border: 1.5px solid #4d869c;\n}\n\n.bouquet-search-btn {\n  padding: 7px 18px;\n  border-radius: 6px;\n  border: none;\n  background: #4d869c;\n  color: #fff;\n  font-weight: bold;\n  font-size: 1em;\n  margin-top: 10px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.bouquet-search-btn:hover {\n  background: #37647a;\n}\n\n.see-more {\n  color: #4d869c;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 0.98em;\n  margin-left: 4px;\n}\n\n/* Ensure .bouquet-deskripsi wraps text and prevents horizontal scroll/overflow */\n.bouquet-deskripsi {\n  display: block;\n  white-space: pre-line;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  max-width: 250px;\n  overflow-x: auto;\n}\n\n/* Prevent table cell overflow for deskripsi */\n.bouquet-table td,\n.bouquet-table th {\n  vertical-align: top;\n  word-break: break-word;\n  white-space: normal;\n  max-width: 260px;\n  overflow-wrap: break-word;\n}\n\n.bouquet-file-preview-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Admin Feedback Table Styles */\n.admin-feedback-table {\n  width: 100%;\n  margin-top: 1rem;\n  border-collapse: collapse;\n  background: #fafbfc;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px 0 rgba(77, 134, 156, 0.07);\n}\n\n.admin-feedback-table th,\n.admin-feedback-table td {\n  border: 1px solid #ccc;\n  padding: 10px 8px;\n  vertical-align: middle;\n  font-size: 1em;\n}\n\n.admin-feedback-table thead {\n  background-color: #f0f0f0;\n}\n\n.admin-feedback-img-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.admin-feedback-table-img {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 4px;\n  display: block;\n  margin: 0 auto;\n}\n\n/* Prevent table header text from wrapping to new line */\n.bouquet-table th,\n.admin-feedback-table th {\n  white-space: nowrap;\n}\n\n/* Prevent action button text from wrapping to new line */\n.bouquet-action-btn,\n.bouquet-edit-btn,\n.bouquet-delete-btn {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  min-height: 32px;\n  line-height: 1.2;\n  padding: 0.3rem 0.8rem;\n}\n\n/* Optional: Prevent sort icon and th text from stacking vertically */\n.bouquet-table th .th-flex,\n.admin-feedback-table th .th-flex {\n  flex-wrap: nowrap;\n  gap: 6px;\n}\n\n/* feedback card detail */\n.feedback-list {\n  font-weight: bolder;\n  font-size: 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 30px;\n}\n\n#feedback-list-container {\n  display: flex;\n  /* flex-direction: column; */\n  justify-content: center;\n  align-items: center; /* ini bikin konten feedback card di tengah */\n}\n\n@media (min-width: 700px) {\n  .feedback-list {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n\n.feedback-card {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start; /* Ubah ini dari center menjadi flex-start */\n  /* flex-direction: column; otomatis taruh isi ke bawah */\n  /* align-items: center; <--- Hapus atau komentari baris ini jika ada duplikasi */\n  text-align: left;\n  width: 350px;\n  max-width: 600px;\n  gap: 12px;\n  padding: 16px;\n  border: 6px solid rgba(255, 27, 27, 0.782);\n  border-radius: 12px;\n  background-color: hsla(44, 100%, 90%, 0.3);\n  max-width: 100%;\n  box-shadow: -8px 8px rgb(55, 216, 55);\n}\n\n.feedback-img-wrapper img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.feedback-content {\n  flex: 1;\n  /* margin-top: 10px; */\n  word-break: break-word;\n}\n\n.feedback-rating {\n  font-weight: bold;\n  margin-bottom: -7px !important;\n  margin-top: 3px !important;\n}\n\n.feedback-text {\n  font-size: 14px;\n  font-weight: bolder;\n  color: #444;\n  margin-top: 8px;\n}\n\n.no-feedback {\n  text-align: center;\n  font-style: italic;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
